import { updateLikesDislikes } from '../api/preference/likeDislikes'
import useEndpointAsFunction from './useEndpointAsFunction'

export const useLikesDislikes = () => {
  const [state, , fn] = useEndpointAsFunction(updateLikesDislikes)
  return [state, fn]
}

export const dummy = () => {}
